import { useEffect } from 'react';

/**
 * Лёгкий хук для управления `<title>` и `<meta description>` без библиотек.
 * Для SPA — этого достаточно: краулеры Яндекса и Google умеют ждать рендер
 * (SSR не нужен для маркетинговой страницы такого размера).
 *
 * Использование:
 *   usePageMeta({ title: 'Статьи · СтартКласс', description: 'Полезное...' });
 */
export default function usePageMeta({ title, description, canonical }) {
    useEffect(() => {
        if (title) {
            const prev = document.title;
            document.title = title;
            // не возвращаем prev при unmount — следующая страница свой title поставит
        }
        if (description) {
            let tag = document.querySelector('meta[name="description"]');
            if (!tag) {
                tag = document.createElement('meta');
                tag.setAttribute('name', 'description');
                document.head.appendChild(tag);
            }
            tag.setAttribute('content', description);
        }
        if (canonical) {
            let link = document.querySelector('link[rel="canonical"]');
            if (!link) {
                link = document.createElement('link');
                link.setAttribute('rel', 'canonical');
                document.head.appendChild(link);
            }
            link.setAttribute('href', canonical);
        }
    }, [title, description, canonical]);
}
